// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"8b6042de","442":"9bda8558","476":"8b6042de"}[chunkId] + ".chunk.css";
};